import React from 'react';
import {Row, ContenedorForm, HeaderForm, CuerpoForm, TituloForm, ContainerEdit, ContainerCol } from '../componentes_generales/componentes_formulario/contenedores/';
import { LabelForm, LabelCabecera } from '../componentes_generales/componentes_formulario/labels/';
import { InputText } from '../componentes_generales/componentes_formulario/inputs/inputtext';
import global_axios  from '../../funciones_globales/interaccionapi';
import { cargarCatalogosGenericoAsync, cargarCatalogos_Otros } from '../../funciones_globales/catalogos';
import moment from 'moment';
import PickerFecha from '../componentes_generales/componentes_formulario/datepicker/datepicker';
import InputSearch from '../componentes_generales/componentes_formulario/inputs/inputsearch';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { generar_LogAuditoriaIngresoForm, generar_LogAuditoriaSalidaForm } from '../../actions/generales/act_gen03';
import ReactSelectAsync from '../componentes_generales/componentes_formulario/selects/react-select-async';
import '../componentes_generales/componentes_formulario/contenedores/flexbox.css'
import { desformatearNumeroDecimal, formatearNumeroDecimal, formatearFechaMoment_a_String } from '../../funciones_globales/format';
import { validarFechaTransaccionSeleccionada, validarPermisoAcceso } from '../../funciones_globales/utils';
import { getFechaProcesoPorModulo } from '../../funciones_globales/manejosesion';
import { cambiar_VisualizacionLoading } from '../../actions/generales/act_gen01';

class FormComp06 extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            //Global
            movimientoId: '',
            operacion: 'G', //G GUARDAR - M Modificar
            permiso: null, //G SOLO GUARDAR => M Guardar & Modificar
            planVigente: null,
            fecha_proceso: null,
            num_diario: null,
            ult_transaccion: null,

            //SELECTS ASYNC
            ident_prov_sel: null,

            //
            nombreProveedor: null,
            ctaAnticipo: null,
            aprobado: null,
            idOrdenPago: null,
            //InputText
            valor: '',
            concepto: '',
            cedulaPrv: '',


        };

        //Constructors 

        //OVERCONTROLS
        this.validarMonto = this.validarMonto.bind(this);
        this.actualizarCampos = this.actualizarCampos.bind(this);

        //OPERACIONES
        this.getProveedor = this.getProveedor.bind(this);

        //BOTONES ACCION
        this.getAntProvById = this.getAntProvById.bind(this);
        this.guardarAntProvedor = this.guardarAntProvedor.bind(this);
        this.limpiarPantalla = this.limpiarPantalla.bind(this);
        this.anularAntProveedor = this.anularAntProveedor.bind(this);
    }

    //OVERCONTROLS
    actualizarCampos(event){
        const target = event.target;       
        const name = target.name;    
        const value = target.type === 'checkbox'? target.checked : target.value;
        this.setState({
          [name]: value
        });
    }

    validarMonto(event){
        const target = event.target;       
        const name = target.name;
        const value = target.value;

        var valor = value;
        var newValue = 0;
        if(valor !== ""){
            newValue = desformatearNumeroDecimal(valor);
            valor = newValue;
        }
        
        if(isNaN(parseFloat(valor))===true || valor===""){
            this.setState({[name]: ''});
        }else{            
            if(parseFloat(valor) <= 0){
                this.setState({[name]: ''});
            }else{
                this.setState({[name]: formatearNumeroDecimal(valor)})
            }
        }
    }

    //CARGA
    getOptions_Proveedores(input, callback){
        if (input.toString().length >= 2 ){
            let cadena_busq = '&cadena_busq=' + input;
            cargarCatalogosGenericoAsync('/proveedores?tipo=catalogo', cadena_busq, callback)
        }
    }

    cargarObjetos(ruta){
        return new Promise((resolve, reject) => {
            global_axios.get(ruta)
            .then((response)=>{
                resolve(response.data)
            })
            .catch((err)=>{

                reject('No existe movimiento a presentar...');
            });
        });
    }

    cargarCuentasContables(cuenta, plan){
        return new Promise((resolve, reject) => {
            //CUENTA + PLANVIGENTE
            global_axios.get('/cuentas/'+cuenta+'/'+plan)
            .then((response)=>{                
                resolve(response.data);
            })
            .catch((err)=>{
                reject('Error al cargar datos de catálogos desde API: ' + err);
            });
        });
    }

    //OPERACIONES
    getProveedor(){
        if(this.state.ident_prov_sel !== null){
            var ctaAnticipo = "";

            this.cargarObjetos('/proveedores?tipo=indt_proveedor&ident='+this.state.ident_prov_sel.value).then((result)=>{
                if(result.length > 0){
                    this.setState({nombreProveedor: result[0].Descripcion, ctaAnticipo: result[0].Cuenta_anticipo,
                    cedulaPrv: result[0].CedulaRuc});

                    //cod_proveedor=result[0].Codigo;
                    //cuenta = result[0].Cuenta;
                    ctaAnticipo = result[0].Cuenta_anticipo

                    //Proceso de cuenta de anticipo
                    if(ctaAnticipo!==null){
                        if(ctaAnticipo.toString().trim()!==""){
                            this.cargarCuentasContables(ctaAnticipo.toString().trim(),this.state.planVigente).then((r_ctaAnticipo)=>{

                                if(r_ctaAnticipo===null){
                                    this.setState({cuentaAntProveedor: null})
                                    alert("La cuenta de anticipo no se encuentra registrada en el sistema");
                                }
                            })
                        }else{
                            alert("El proveedor seleccionado no posee cta. de anticipo")
                            this.limpiarPantalla('A')
                        }
                    }else{
                        alert("El proveedor seleccionado no posee cta. de anticipo")
                        this.limpiarPantalla('A')
                    }
                }else{
                    this.setState({ident_prov_sel:null}, ()=>{
                        if(result.length <= 0 && this.state.ident_prov_sel===null){
                            alert('No existen coincidencias con proveedor seleccionado');
                        }
                    })
                }
            })
        }
    }

    //CICLO REACT
    componentDidMount(){
        Promise.all([   
            cargarCatalogos_Otros('GEN-PLANVIG'),
            this.cargarObjetos('/aprobaciontransacciones?estado=A'),      
            this.props.generar_LogAuditoriaIngresoForm('0606') ])
        .then(([ r_planVigente, reqAprobacion ]) => { 
            var aprobacion = "";
            if(reqAprobacion.length>0){
                aprobacion = 'N';
            }else{
                aprobacion = 'S';
            }

            //FECHA DE PROCESO POR MODULO
            let fechaProceso = getFechaProcesoPorModulo('06');

            console.log("FECHA SWITCH: ",this.props.permiteCambioFProceso)           
            this.setState({planVigente: r_planVigente[0].value, aprobado: aprobacion,
                permiso: this.props.permiso,
                fecha_proceso: moment(fechaProceso, "DD/MM/YYYY")})
        });
    }

    componentWillUnmount(){
        this.props.generar_LogAuditoriaSalidaForm('0606');
    }


    //BOTONES
    getAntProvById(){
        if(this.state.movimientoId === ''){
            alert("Digite un movimiento");
        }else if(parseInt(this.state.movimientoId,10) <= 0 ){
            alert("Movimiento no válido");
            this.setState({movimientoId: ''});
        }else{

            global_axios({
                method: 'GET',
                url: '/anticipos/'+this.state.movimientoId.toString()
            })
            .then((response)=>{ 
                var anticipo = response.data;
                console.log("RESPUESTA: ", response)
                if(anticipo!==null){
                    if(anticipo.ordenDet!==null){
                        //PROVEEDOR
                        if(anticipo.ordenDet.prov!==null){
                            var proveedor = {};
    
                            proveedor.value = anticipo.PROVEEDOR;
                            proveedor.label = anticipo.ordenDet.prov.RazonSocial.toString().trim();
                            this.setState({ident_prov_sel: proveedor, 
                                cedulaPrv: anticipo.ordenDet.prov.CedulaRuc,
                                concepto: anticipo.ordenDet.Concepto.toString().trim(),
                                valor: anticipo.VALOR});
    
                            this.setState({idOrdenPago: anticipo.idOrdenPago,
                                operacion: 'M'})
                        }
                    }else{
                        alert("Anticipo no relacionado con ordenes de pago, informar a sistemas")
                    }
                }else{
                    alert("No existen coincidencias...")
                }
            })
            .catch((error)=>{                
                alert(error.response?error.response.data.msg:error.message);      
            });
        }
    }

    guardarAntProvedor(){
        var errors = "";
        var proceder = true;
        //FECHA DE PROCESO POR MODULO
        let fechaProceso = getFechaProcesoPorModulo('06');
        
        // Validación de fecha de proceso que se puede cambiar ------------------------------
        if (this.props.permiteCambioFProceso==='S'){
            let resultadoValidFProceso = validarFechaTransaccionSeleccionada(this.state.fecha_proceso, moment(fechaProceso, 'DD/MM/YYYY'), this.props.diasPermiteCambioFProceso);
            if(resultadoValidFProceso.esValida===false){
                proceder = false;
                errors = errors + resultadoValidFProceso.msg+'\n'
            }
        }

        //Validación de permisos
        let operacion = validarPermisoAcceso(this.state.operacion, this.state.permiso)
        if(operacion.esValido===false){
            proceder = false;
            errors = errors+operacion.msg
        }

        //Validación campos
        if(this.state.ident_prov_sel===null){
            proceder = false;
            errors = errors+"- No ha seleccionado un proveedor\n"
        }

        if(this.state.concepto===""){
            proceder = false;
            errors = errors+"- No ha ingresado un concepto\n"
        }

        if(this.state.valor===""){
            proceder = false;
            errors = errors+"- No ha ingresado un valor\n"
        }else if(Math.round(parseFloat(this.state.valor,10)*100)/100 <=0){
            proceder = false;
            errors = errors+"- El valor a ingresar no puede ser menor o igual a 0\n"
        }
        console.log("PROCEDER: ",proceder)
        if(proceder === true){
            var data = {};
            //Asignacion data

            data.Proveedor = this.state.ident_prov_sel.value;
            data.Concepto = this.state.concepto.toString().toUpperCase();
            var valor = desformatearNumeroDecimal(this.state.valor); 
            data.Valor = Math.round(valor*100)/100;
            data.FechaProceso = formatearFechaMoment_a_String(this.state.fecha_proceso);
            data.Aprobacion = this.state.aprobado;
            data.Localidad = '01';
            data.IdRegAudit= this.props.idRegAudit;
            data.Usuario = this.props.usuario;

            if(this.state.operacion==='M'){
                data.idOrdenPago = this.state.idOrdenPago;
            }
            

            let config_request = {
                method: this.state.operacion==='G'?'POST':'PATCH',
                url: this.state.operacion==='G'?'/anticipos/':'/anticipos/'+this.state.movimientoId,
                data
            }

            console.log("DATA A ENVIAR: ", config_request)

            this.props.cambiar_VisualizacionLoading(true);
            global_axios(config_request)
            .then((response)=> {   
                this.props.cambiar_VisualizacionLoading(false);  
                console.log("DATA RECIBIDA: ", response)           
                alert(response.data.msg);
                this.setState({ult_transaccion: response.data.transaction, num_diario: response.data.diario})
                this.limpiarPantalla('A');

            })
            .catch((error)=>{ 
                this.props.cambiar_VisualizacionLoading(false);                           
                alert(error.response?error.response.data.msg:error.message);
            });
        }else{
            alert(errors)
        }
    }

    anularAntProveedor(){
        var errors = "";
        var proceder = true;

        //Validación de permisos
        let operacion = validarPermisoAcceso(this.state.operacion, this.state.permiso)
        if(operacion.esValido===false){
            proceder = false;
            errors = errors+operacion.msg
        }

        if(proceder === true){
            var data = {}

            data.IdRegAudit = this.props.IdRegAudit;
            data.idOrdenPago = this.state.idOrdenPago;

            global_axios({
                url: '/anticipos/'+this.state.movimientoId,
                method: 'DELETE',
                headers: {'idregaudit': this.props.IdRegAudit, 
                'operacion':this.state.idOrdenPago }
              })
              .then((response)=>{
                alert(response.data.msg);
                this.setState({ult_transaccion: response.data.transaction})
                this.limpiarPantalla('A');
                this.setState({operacion: 'G'});
              })
              .catch((error)=>{                
                alert(error.response?error.response.data.msg:error.message);
                this.limpiarPantalla('A');
            });
        }else{
            alert(errors);
        }
    }

    limpiarPantalla(op){

        this.setState({
            ident_prov_sel: null,
            nombreProveedor: null,
            ctaAnticipo: null,
            idOrdenPago: null,
            valor: '',
            concepto: '',
            cedulaPrv: '',
            operacion: 'G'
        })

        if(op==='A'){
            this.setState({movimientoId: ''})
        }
    }

    changeProveedor(value){
        this.setState({ident_prov_sel: value!==null?value:null}, ()=>{
            this.getProveedor(value);
        })
    }

    render(){
        return(
            <ContenedorForm porc_ancho={80}>
             <HeaderForm>
                <TituloForm>Anticipo Proveedor</TituloForm>
                <LabelCabecera>Ult. trans.: {this.state.ult_transaccion}</LabelCabecera>
                <LabelCabecera>N°. diario.: {this.state.num_diario}</LabelCabecera> 
            </HeaderForm>
            <CuerpoForm>
            <ContainerEdit>
                <Row>
                    <ContainerCol className='col-sm-2'>
                        <LabelForm>Movimiento:</LabelForm>
                        <InputSearch tipoInput='text' nombre='movimientoId' placeholder='Movimiento' valor={this.state.movimientoId} func_CambiarValor={this.actualizarCampos} 
                        func_BuscarValor={this.getAntProvById} func_OnFocus={()=>{this.limpiarPantalla('B')}} maxLength='10'/> 
                    </ContainerCol>
                    <ContainerCol className='col-sm-2 col-sm-offset-8'>
                        <LabelForm>Fecha. Trans.:</LabelForm>
                        <PickerFecha fechaSeleccionada={this.state.fecha_proceso} disabled={!(this.props.permiteCambioFProceso==='S')} func_onChange={(fechaEscogida)=>{this.setState({fecha_proceso: fechaEscogida})}}/>
                    </ContainerCol>
                </Row>
            </ContainerEdit>
                <ContainerCol className='col-sm-3'>   
                    <LabelForm>Proveedor:</LabelForm>
                    <ReactSelectAsync value={this.state.ident_prov_sel} disabled={false} func_loadOptions={this.getOptions_Proveedores} func_onChange={(value)=>{ this.changeProveedor(value) } /*this.setState({ident_prov_sel: value!==null?value:null})}*/ } /*func_onBlur={(value)=>{this.getProveedor(value)}}*//>
                </ContainerCol>
                <ContainerCol className='col-sm-2'>
                    <LabelForm>Cédula:</LabelForm>
                    <InputText name='cedulaPrv' type="text" disabled={true} value={this.state.cedulaPrv}  className='form-control input-sm' placeholder='Cédula' onChange={this.actualizarCampos}/>
                </ContainerCol>
                <ContainerCol className='col-sm-5'>
                    <LabelForm>Concepto:</LabelForm>
                    <InputText name='concepto' mayusculas={true} value={this.state.concepto}  className='form-control input-sm' placeholder='Concepto' onChange={this.actualizarCampos} maxLength='60'/>
                </ContainerCol>
                <ContainerCol className='col-sm-2'>
                    <LabelForm>Valor:</LabelForm>
                    <InputText name='valor' type="text" value={this.state.valor}  className='form-control input-sm' onChange={this.actualizarCampos} onBlur={this.validarMonto}/>
                </ContainerCol>
                <Row>                               
                    <ContainerCol className='col-sm-12'> 
                        <br/>                                   
                        <div className="btn-group pull-right">                                    
                            <button type='button' className='btn btn-primary btn-sm' /*disabled={this.estadoGuardar()}*/ onClick={this.guardarAntProvedor}><i className='fa fa-floppy-o fa-lg'/> Guardar</button>
                            <button type='button' className='btn btn-sm' onClick={()=>{this.limpiarPantalla('A')}}><i className='fa fa-trash-o fa-lg'/> Limpiar</button>
                            <button type='button' className='btn btn-danger btn-sm' disabled={this.state.operacion==='M'?false:true} onClick={this.anularAntProveedor}><i className='fa fa-window-close  fa-lg'/> Anular</button>
                        </div>                                                                        
                    </ContainerCol>
                </Row>
            </CuerpoForm>
            </ContenedorForm>  
        )
    }

}


const mapStateToProps = ((state) => {
    return {permiso: state.sesion.valoresSesionForm.Permiso,
            usuario: state.sesion.valoresSesionForm.Usuario,
            idRegAudit: state.sesion.valoresSesionForm.IdRegAudit,
            permiteCambioFProceso: state.sesion.valoresSesionForm.CambioFechaProceso,
            diasPermiteCambioFProceso: state.sesion.valoresSesionForm.CantidadDias,
            departamento : state.sesion.valoresSesionForm.Departamento
        }
});
      
const mapDispatchToProps = ((dispatch) => {  
return bindActionCreators({ generar_LogAuditoriaIngresoForm, generar_LogAuditoriaSalidaForm, 
                            cambiar_VisualizacionLoading}, dispatch)
});
    
export default connect (mapStateToProps, mapDispatchToProps)(FormComp06);